import React from 'react';
import { Link } from 'react-router-dom';
import HeroCarousel from '../components/HeroCarousel';
import SEO from '../components/seo/SEO';
import './Home.css';
import '../styles/CTA.css';
import WhyChooseUs from './WhyChooseUs';
import Industries from './Industries';
import ServicesOverview from './ServicesOverview';
import ValueTriangle from './ValueTriangle';
import CaseStudiesOverview from './CaseStudiesOverview';
import Testimonials from '../components/ui/Testimonials';

const Home = () => {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Cospin - Accelerating Digital Transformation',
    description: 'Cospin helps founders and CXOs build Global Capability Centers (GCCs), ship products faster, and harden infrastructure—practically, transparently, and without fluff.',
    mainEntity: {
      '@type': 'Organization',
      name: 'Cospin',
      url: 'https://www.cospin.in'
    }
  };

  return (
    <div className="home">
      <SEO
        title="Accelerating Digital Transformation"
        description="Cospin helps founders and CXOs build Global Capability Centers (GCCs), ship products faster, and harden infrastructure—practically, transparently, and without fluff."
        keywords="digital transformation, GCC, global capability centers, product engineering, infrastructure, security, AI innovation, consulting, India"
        url="https://www.cospin.in"
      />

      {/* Hero Section with Carousel */}
      <section className="hero">
        <HeroCarousel />
      </section>

      {/* Value Proposition */}
      <WhyChooseUs />

      <div className="about-content-section about-value-triangle-section">
        <ValueTriangle />
      </div>

      {/* Industries Section */}
      <Industries />

      {/* Case Studies */}
      <CaseStudiesOverview />

      {/* Testimonials */}
      <Testimonials />

      {/* CTA Section */}
      <div className="cta-section">
        <div className="cta-content">
          <h2>Ready to Accelerate Your Digital Transformation?</h2>
          <p>Let's discuss how Cospin can help you achieve speed, clarity, and impact.</p>
          <Link to="/contact" className="cta-button">
            Get Started Today
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
